<!--
 * @Description: 我的工作任务
 * @Author: PF
 * @Date: 2023-02-23 17:07:24
 * @LastEditors: PF
 * @LastEditTime: 2026-09-08 13:42:28
-->
<template>
  <div>
    <el-dialog class="wp80 hp90" :model-value="openDaiBanShiXiang" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">我的工作任务</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDaiBanShiXiang', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="mb0" :model="dbParms" style="display: flex;" @submit.enter.prevent>
              <el-form-item style="width: 220px;margin: 10px 10px 10px 0;">
                <el-date-picker v-model="dbRqqj" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="YYYY-MM-DD" @change="initDaiBan()" />
              </el-form-item>
              <el-form-item style="width: 200px;margin: 10px 10px 10px 0;">
                <el-select class="w260" placeholder="工作类别" v-model="dbParms.dbgzlbid" clearable filterable @change="initDaiBan()">
                  <el-option v-for="item in gzlbData" :key="item.id" :label="item.gzlbmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item style="width: 200px;margin: 10px 10px 10px 0;">
                <el-input class="w260" placeholder="工作任务标题" v-model="dbParms.gzrwbt" clearable @clear="initDaiBan()" @keyup.enter="initDaiBan()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="initDaiBan()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item style="width: 200px;margin: 10px 10px 10px 0;">
                <el-input class="w260" placeholder="委派人" v-model="dbParms.wprxm" clearable @clear="initDaiBan()" @keyup.enter="initDaiBan()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="initDaiBan()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="mb10">
              <div class="button-box">
              <el-button v-if="xtszData.rcgz.sfxs" type="primary" plain round @click="openAddRiChang = true" style="height: 35px;"><span class="iconfont icon-chuangjian el-icon--left"></span>添加日常工作</el-button>
              <el-button v-if="xtszData.lsgz.sfxs" type="primary" plain round @click="lsgzAdd = true" style="height: 35px;"><span class="iconfont icon-chuangjian el-icon--left"></span>委派临时工作</el-button>
                <el-button type="success" plain round @click="daiBanActive = 'db'; initDaiBan()">待 办</el-button>
                <el-button type="success" plain round @click="daiBanActive = 'yb'; initDaiBan()">已 办</el-button>
                <el-button type="success" plain round @click="daiBanActive = 'hl'; initDaiBan()">忽 略</el-button>
                <el-button type="success" plain round @click="daiBanActive = 'yyj'; initDaiBan()" v-if="xtszData.yyj.sfxs">已 移 交</el-button>
                <el-button type="success" plain round @click="daiBanActive = 'ywp'; initDaiBan()" v-if="xtszData.ywp.sfxs">已 委 派</el-button>
                <el-button type="success" plain round @click="daiBanActive = 'jr'; initDaiBan()">今日工作</el-button>
                <el-button type="success" plain round @click="daiBanActive = 'bz'; initDaiBan()">本周工作</el-button>
                <el-button type="success" plain round @click="daiBanActive = 'by'; initDaiBan()">本月工作</el-button>
              </div>
            </div>
              <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table v-if="daiBanActive=='db' || daiBanActive=='yb' || daiBanActive=='hl' || daiBanActive=='yyj' || daiBanActive=='jr' || daiBanActive=='bz' || daiBanActive=='by'" :data="dbData" :default-sort="{ prop: dbParms.order, order: dbParms.sort }" v-loading="gzrwLading" @sort-change="dataGrid.sortChange" height="100%">
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="工作任务标题" prop="gzrwbt" align="center" min-width="200" xueshengxuexichengjishow-overflow-tooltip />
              <el-table-column label="工作类别" prop="dbgzlbmc" align="center" width="200" show-overflow-tooltip />
              <el-table-column label="完成时间" prop="wcsj" v-if="daiBanActive=='yb'" align="center" width="154" show-overflow-tooltip />
              <el-table-column label="要求完成时间" prop="yqwcsj" align="center" width="154" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span :style=" scope.row.zt == ztData.cswc ? 'color:#F56C6C' : ''"> {{ scope.row.yqwcsj }}</span>
                </template>
              </el-table-column>
              <el-table-column label="委派时间" prop="wpsj" align="center" width="154" show-overflow-tooltip />
              <el-table-column label="委派人" prop="wprxm" align="center" show-overflow-tooltip />
              <el-table-column v-if="daiBanActive == 'db' || daiBanActive == 'hl' || daiBanActive == 'jr' || daiBanActive == 'bz' || daiBanActive == 'by' " label="操作" align="center" width="180">
                <template #default="scope">
                  <span v-if="scope.row.bgdbsx.id !== dbztData.jiaoxuerizhi && scope.row.bgdbsx.id !== dbztData.xunjian">
                    <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.zhibanrizhi" @click="openZhiBanRiZhi=true,row=scope.row">填报日志</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.zuzhishiwu" @click="openShiWuChuLi=true;row=scope.row">事务处理</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaoshijihuashijuanzujuan" @click="openShangChuanShiJuan=true;row=scope.row">上传试卷</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaoshijihuashijuanzujuanshenpi" @click="openShenPiShiJuan=true;row=scope.row">审核</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.tiaoke" @click="openTiaoKe=true,row=scope.row">办理</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.jiaoxuegongzuojiancha" @click="openJiaoXueJianCha=true,row={ jxgzjcjlid: scope.row.dbgzid }">检查</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.daike" @click="openDaiKe=true,row=scope.row">办理</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.linshigongzuo" @click="openWanChengLinShi=true,row=scope.row">完成</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.gudinggongzuo" @click="openWanChengGuDing=true,row=scope.row">完成</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.richanggongzuo" @click="openWanChengRiChang=true,row=scope.row">完成</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.jiaoxuesheji" @click="openJiaoXueSheJi=true,row={ id: scope.row.dbgzid }">上传</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.buzhizuoye" @click="openBuZhiZuoYe=true, row={ id: scope.row.dbgzid }">布置作业</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.xueqijiaoxuejihua" @click="openJiaoXueJiHua=true, row=scope.row">教学计划</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.pigaizuoye" @click="openPiGaiZuoYe=true;row={ id: scope.row.dbgzid }">批改</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kejian" @click="openKeJian=true;row={ id: scope.row.dbgzid }">上传课件</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.guizhangzhiduyuedu" @click="openGuiZhangZhiDuYueDu=true;row={ id: scope.row.dbgzid }">阅读</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.weituixueshengsuguan" @click="openWeiGuiXueShengSuGuan=true;row={ id: scope.row.dbgzid }">查看</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.weiguixueshengbanzhuren" @click="openWeiGuiXueShengBanZhuRen=true;row={ id: scope.row.dbgzid }">查看</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.huiyiguanli" @click="openHuiYiGuanLi=true;row={ id: scope.row.dbgzid }">查看</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaohexiangmukaoheren" @click="openKaoHeXiangMuKaoHeRen=true;row={ id: scope.row.dbgzid }">查看</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaohexiangmupingjiaren" @click="openKaoHeXiangMuPingJiaRen=true;row={ id: scope.row.dbgzid }">评价</el-button>
                    <el-button link type="primary" v-else @click="isSPXQ = true; SPXQObj = { title: '详情', id: scope.row.dbgzid, lx: daiBanActive }">办理</el-button>
                    <el-button link type="primary" v-if="daiBanActive !== 'hl'" @click="hulueClick(scope.row)">忽略</el-button>
                  </span>
                  <span v-if="scope.row.bgdbsx.id == dbztData.jiaoxuerizhi">
                    <el-button link type="primary" @click="openJiaoXueRiZhi = true, row = { id: scope.row.dbgzid }">提交</el-button>
                    <el-button link type="primary" v-if="daiBanActive !== 'hl'" @click="hulueClick(scope.row)">忽略</el-button>
                  </span>
                </template>
              </el-table-column>
              <el-table-column v-if="daiBanActive == 'yb'" label="操作" align="center" width="180">
                <template #default="scope">
                  <span v-if="scope.row.bgdbsx.id !== dbztData.jiaoxuerizhi">
                    <!-- <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.zhibanrizhi" @click="openZhiBanRiZhiDetail=true,row=scope.row">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.zuzhishiwu" @click="openShiWuChuLiDetail=true;row=scope.row">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaoshijihuashijuanzujuan" @click="openShangChuanShiJuanDetail=true;row=scope.row">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaoshijihuashijuanzujuanshenpi" @click="openShenPiShiJuanDetail=true;row=scope.row">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.tiaoke" @click="openTiaoKeDetail=true,row=scope.row">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.jiaoxuegongzuojiancha" @click="openJiaoXueJianCha=true,row={ jxgzjcjlid: scope.row.dbgzid }">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.daike" @click="openDaiKeDetail=true,row=scope.row">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.linshigongzuo" @click="openWanChengLinShiDetail=true,row=scope.row">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.gudinggongzuo" @click="openWanChengGuDingDetail=true,row=scope.row">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.richanggongzuo" @click="openWanChengRiChangDetail=true,row=scope.row">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.jiaoxuesheji" @click="openJiaoXueSheJiDetail=true,row={ id: scope.row.dbgzid }">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.buzhizuoye" @click="openBuZhiZuoYeDetail=true, row={ id: scope.row.dbgzid }">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.xueqijiaoxuejihua" @click="openJiaoXueJiHuaDetail=true, row={dbgzid: scope.row.dbgzid}">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.pigaizuoye" @click="openPiGaiZuoYeDetail=true;row={ id: scope.row.dbgzid }">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kejian" @click="openKeJianDetail=true;row={ id: scope.row.dbgzid }">详情</el-button> -->
                    <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.guizhangzhiduyuedu" @click="openGuiZhangZhiDuYueDu=true;row={ id: scope.row.dbgzid }">阅读</el-button>
                    <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.weituixueshengsuguan" @click="openWeiGuiXueShengSuGuan=true;row={ id: scope.row.dbgzid }">查看</el-button>
                    <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.weiguixueshengbanzhuren" @click="openWeiGuiXueShengBanZhuRen=true;row={ id: scope.row.dbgzid }">查看</el-button>
                    <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.huiyiguanli" @click="openHuiYiGuanLi=true;row={ id: scope.row.dbgzid, dbzt: ztData.ywc }">查看</el-button>
                    <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.xunjian" @click="openXunJianDetail=true;row={ id: scope.row.dbgzid }">详情</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaohexiangmukaoheren" @click="openKaoHeXiangMuKaoHeRen=true;row={ id: scope.row.dbgzid }">查看</el-button>
                    <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaohexiangmupingjiaren" @click="openKaoHeXiangMuPingJiaRenDetail=true;row={ id: scope.row.dbgzid }">查看</el-button>
                    <!-- <el-button link type="primary" v-else @click="isSPXQDetail = true; SPXQObj = { title: '详情', id: scope.row.dbgzid, lx: daiBanActive }">详情</el-button> -->
                  </span>
                  <!-- <span v-if="scope.row.bgdbsx.id == dbztData.jiaoxuerizhi">
                    <el-button link type="primary" @click="openJiaoXueRiZhiDetail = true, row = { id: scope.row.dbgzid }">详情</el-button>
                  </span> -->
                </template>
              </el-table-column>
              <!-- 冻结列-Left END -->
            </el-table>

            <!-- 委派临时任务BEGIN -->
            <el-table v-if="daiBanActive == 'ywp'" :data="dbData" :default-sort="{ prop: dbParms.order, order: dbParms.sort }" v-loading="gzrwLading" @sort-change="dataGrid.sortChange" height="100%">
              <el-table-column label="工作任务标题" prop="gzrwbt" align="center" show-overflow-tooltip />
              <el-table-column label="要求完成时间" prop="yqwcsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span :style="scope.row.isDydqrq === true || scope.row.zt == ztData.cswc ? 'color:#F56C6C' : ''"> {{ scope.row.yqwcsj }}</span>
                </template>
              </el-table-column>
              <el-table-column label="部门" prop="bmmc" align="center" width="160" show-overflow-tooltip />
              <el-table-column label="负责人" prop="fzrxm" align="center" width="160" show-overflow-tooltip />
              <el-table-column label="移交人" prop="wprxm" align="center" show-overflow-tooltip />
              <el-table-column label="移交时间" prop="wpsj" align="center" show-overflow-tooltip />
              <el-table-column label="操作" align="center" width="180">
                <template #default="scope">
                  <el-button link type="success" @click="openWeiPaiDetail=true; row=scope.row">详情</el-button>
                  <!-- <el-button link type="primary" v-if="scope.row.zt==ztData.dwc || scope.row.zt==ztData.yhl" @click="openEditYwp=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" v-if="scope.row.zt==ztData.dwc || scope.row.zt==ztData.yhl" @click="dbDataGrid.multipleSelection=[scope.row.id]; weipaidel()">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
                      <pagination :pagination="paginationObj" @ReturnData="initDaiBan" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <!-- 待办事项 BEGIN -->
  <addrichang v-if="openAddRiChang" v-model:openAddRiChang="openAddRiChang" :row="row" @ReturnData="initDaiBan()" />
  <addlsgz v-if="lsgzAdd" v-model:lsgzAdd="lsgzAdd" :row="row" @ReturnData="initDaiBan()" />
  <shenpixiangqing v-if="isSPXQ" v-model:isSPXQ="isSPXQ" :SPXQObj="SPXQObj" @ReturnData="initDaiBan" />
  <zhibanrizhi v-if="openZhiBanRiZhi" v-model:openZhiBanRiZhi="openZhiBanRiZhi" :row="row" @ReturnData="initDaiBan()" />
  <zhibanrizhidetail v-if="openZhiBanRiZhiDetail" v-model:openZhiBanRiZhi="openZhiBanRiZhiDetail" :row="row" @ReturnData="initDaiBan()" />
  <shiwuchuli v-if="openShiWuChuLi" v-model:openShiWuChuLi="openShiWuChuLi" :row="row" @ReturnData="initDaiBan()" />
  <shiwuchulidetail v-if="openShiWuChuLiDetail" v-model:openDetail="openShiWuChuLiDetail" :row="row" @ReturnData="initDaiBan()" />
  <shangchuanshijuan v-if="openShangChuanShiJuan" v-model:openAdd="openShangChuanShiJuan" :row="row" @ReturnData="initDaiBan()" />
  <shangchuanshijuandetail v-if="openShangChuanShiJuanDetail" v-model:openAdd="openShangChuanShiJuanDetail" :row="row" @ReturnData="initDaiBan()" />
  <shenpishijuan v-if="openShenPiShiJuan" v-model:openShenPi="openShenPiShiJuan" :row="row" @ReturnData="initDaiBan()" />
  <shenpishijuandetail v-if="openShenPiShiJuanDetail" v-model:openShenPi="openShenPiShiJuanDetail" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshitiaoke v-if="openTiaoKe" v-model:openTiaoKe="openTiaoKe" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshitiaokedetail v-if="openTiaoKeDetail" v-model:openTiaoKe="openTiaoKeDetail" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshijiaoxuejiancha v-if="openJiaoXueJianCha" v-model:openJiaoXueJianCha="openJiaoXueJianCha" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshijiaoxuejianchadetail v-if="openJiaoXueJianChaDetail" v-model:openJiaoXueJianCha="openJiaoXueJianChaDetail" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshidaike v-if="openDaiKe" v-model:openDaiKe="openDaiKe" :row="row" @ReturnData="initDaiBan()" />
  <wanchenglinshi v-if="openWanChengLinShi" v-model:openWanCheng="openWanChengLinShi" :row="row" @ReturnData="initDaiBan()" />
  <wanchenglinshidetail v-if="openWanChengLinShiDetail" v-model:openWanCheng="openWanChengLinShiDetail" :row="row" @ReturnData="initDaiBan()" />
  <wanchengguding v-if="openWanChengGuDing" v-model:openWanCheng="openWanChengGuDing" :row="row" @ReturnData="initDaiBan()" />
  <wanchenggudingdetail v-if="openWanChengGuDingDetail" v-model:openWanCheng="openWanChengGuDingDetail" :row="row" @ReturnData="initDaiBan()" />
  <wanchengrichang v-if="openWanChengRiChang" v-model:openWanCheng="openWanChengRiChang" :row="row" @ReturnData="initDaiBan()" />
  <wanchengrichangdetail v-if="openWanChengRiChangDetail" v-model:openWanCheng="openWanChengRiChangDetail" :row="row" @ReturnData="initDaiBan()" />
  <!-- <editywp v-if="openEditYwp" v-model:openEdit="openEditYwp" :row="row" @ReturnData="initDaiBan()" /> -->
  <weipaidetail v-if="openWeiPaiDetail" v-model:openWeiPaiDetail="openWeiPaiDetail" :row="row" @ReturnData="initDaiBan()" />
  <jiaoxueshejiadd v-if="openJiaoXueSheJi" v-model:openJiaoXueSheJi="openJiaoXueSheJi" :row="row" @ReturnData="initDaiBan()" />
  <jiaoxueshejidetail v-if="openJiaoXueSheJiDetail" v-model:openDetail="openJiaoXueSheJiDetail" :row="row" @ReturnData="initDaiBan()" />
  <addbuzhizuoye v-if="openBuZhiZuoYe" v-model:openBuZhiZuoYe="openBuZhiZuoYe" :row="row" @ReturnData="initDaiBan()" />
  <detailbuzhizuoye v-if="openBuZhiZuoYeDetail" v-model:openBuZhiZuoYe="openBuZhiZuoYeDetail" :row="row" @ReturnData="initDaiBan()" />
  <xueqijiaoxuejihua v-if="openJiaoXueJiHua" v-model:openJiaoXueJiHua="openJiaoXueJiHua" :row="row" @returnData="initDaiBan()" />
  <xueqijiaoxuejihuadetail v-if="openJiaoXueJiHuaDetail" v-model:openDetail="openJiaoXueJiHuaDetail" :row="row" @ReturnData="initDaiBan()" />
  <pigaizuoyelist v-if="openPiGaiZuoYe" v-model:openPiGaiList="openPiGaiZuoYe" :row="row" @ReturnData="initDaiBan()" />
  <shangchuankejian v-if="openKeJian" v-model:openKeJian="openKeJian" :row="row" @ReturnData="initDaiBan()" />
  <guizhangzhiduyuedu v-if="openGuiZhangZhiDuYueDu" v-model:openDetail="openGuiZhangZhiDuYueDu" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshijiaoxuerizhi v-if="openJiaoXueRiZhi" v-model:openJiaoXueRiZhi="openJiaoXueRiZhi" :row="row" @ReturnData="initDaiBan()" />
  <susheweiguixuesheng v-if="openWeiGuiXueShengSuGuan" v-model:openList="openWeiGuiXueShengSuGuan" :row="row" @ReturnData="initDaiBan()" />
  <susheweiguixuesheng v-if="openWeiGuiXueShengBanZhuRen" v-model:openList="openWeiGuiXueShengBanZhuRen" :row="row" @ReturnData="initDaiBan()" />
  <huiyiguanli v-if="openHuiYiGuanLi" v-model:openList="openHuiYiGuanLi" :row="row" @ReturnData="initDaiBan()" />
  <kaohexiangmukaoheren v-if="openKaoHeXiangMuKaoHeRen" v-model:openList="openKaoHeXiangMuKaoHeRen" :row="row" @ReturnData="initDaiBan()" />
  <kaohexiangmupingjiaren v-if="openKaoHeXiangMuPingJiaRen" v-model:openList="openKaoHeXiangMuPingJiaRen" :row="row" @ReturnData="initDaiBan()" />
  <kaohexiangmupingjiarendetail v-if="openKaoHeXiangMuPingJiaRenDetail" v-model:openList="openKaoHeXiangMuPingJiaRenDetail" :row="row" @ReturnData="initDaiBan()" />
  <!-- 待办事项 END -->
</template>

<script setup>
import { defineProps, defineEmits, watchEffect, ref, watch } from 'vue'
import { closeWindow, loadSelect, actionPost } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import { getdbzt } from '@/utils/zidianmeiju'
import pagination from '@/components/pagination.vue'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'

// 待办事项 开始
// import daibanshixiang from '@/components/home/daibanshixiang/list.vue'
import addrichang from '@/components/home/daibanshixiang/tianjiagongzuo/addrichang.vue' // 添加日常
import addlsgz from '@/components/home/daibanshixiang/tianjiagongzuo/addlsgz.vue' // 添加临时工作
import shenpixiangqing from '@/components/home/changguishiwu/tongyong/shenpizhongxin/detail.vue' // 审批详情
import zhibanrizhi from '@/components/home/daibanshixiang/zhibanrizhi/list.vue' // 值班日志
import zhibanrizhidetail from '@/components/home/daibanshixiang/zhibanrizhi/detail.vue' // 值班日志详情
import shiwuchuli from '@/components/home/daibanshixiang/shiwuchuli/list.vue' // 事务处理
import shiwuchulidetail from '@/components/home/daibanshixiang/shiwuchuli/detail.vue' // 事务处理详情
import shangchuanshijuan from '@/components/home/daibanshixiang/zujuan/shangchuan.vue' // 组卷审批 上传试卷
import shangchuanshijuandetail from '@/components/home/daibanshixiang/zujuan/shangchuandetail.vue' // 组卷审批-上传试卷详情
import shenpishijuan from '@/components/home/daibanshixiang/zujuan/shenpishijuan.vue' // 组卷审批 审批试卷
import shenpishijuandetail from '@/components/home/daibanshixiang/zujuan/shenpishijuandetail.vue' // 组卷审批-审批试卷详情
import jiaoshitiaoke from '@/components/home/daibanshixiang/jiaoshitiaoke/list.vue' // 教师调课
import jiaoshitiaokedetail from '@/components/home/daibanshixiang/jiaoshitiaoke/detail.vue' // 教师调课详情
import jiaoshijiaoxuejiancha from '@/components/home/daibanshixiang/jiaoshijiaoxuejiancha/list.vue' // 教师教学检查
import jiaoshijiaoxuejianchadetail from '@/components/home/daibanshixiang/jiaoshijiaoxuejiancha/detail.vue' // 教师教学检查详情
import jiaoshidaike from '@/components/home/daibanshixiang/jiaoshidaike/list.vue' // 教师代课
import wanchenglinshi from '@/components/home/daibanshixiang/tianjiagongzuo/wanchenglinshi.vue' // 完成临时工作
import wanchenglinshidetail from '@/components/home/daibanshixiang/tianjiagongzuo/wanchenglinshidetail.vue' // 完成临时工作详情
import wanchengguding from '@/components/home/daibanshixiang/tianjiagongzuo/wancheng.vue' // 完成固定工作
import wanchenggudingdetail from '@/components/home/daibanshixiang/tianjiagongzuo/wanchengdetail.vue' // 完成固定工作详情
import wanchengrichang from '@/components/home/daibanshixiang/tianjiagongzuo/wanchengrichang.vue' // 完成日常工作
import wanchengrichangdetail from '@/components/home/daibanshixiang/tianjiagongzuo/wanchengrichangdetail.vue' // 完成日常工作详情
// import editywp from '@/components/home/daibanshixiang/tianjiagongzuo/edit.vue' // 修改工作
import weipaidetail from '@/components/home/daibanshixiang/tianjiagongzuo/detail.vue' // 委派详情
import jiaoxueshejiadd from '@/components/home/daibanshixiang/jiaoxuesheji/jiaoxueshejiadd.vue' // 教学设计添加
import jiaoxueshejidetail from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/detailjiaoxuesheji.vue' // 教学设计详情
import addbuzhizuoye from '@/components/home/daibanshixiang/jiaoxuesheji/zuoyeadd.vue' // 布置作业添加
import detailbuzhizuoye from '@/components/home/daibanshixiang/jiaoxuesheji/zuoyedetail.vue' // 布置作业详情
import xueqijiaoxuejihua from '@/components/home/daibanshixiang/xueqijiaoxuejihua/list.vue' // 学期教学计划
import xueqijiaoxuejihuadetail from '@/components/home/daibanshixiang/xueqijiaoxuejihua/detail.vue' // 学期教学计划详情
import pigaizuoyelist from '@/components/home/daibanshixiang/pigaizuoye/pigailist.vue' // 批改作业列表
import shangchuankejian from '@/components/home/daibanshixiang/jiaoxuesheji/kejianadd.vue' // 上传课件
import guizhangzhiduyuedu from '@/components/guizhangzhidu/guizhangzhiduguanli/yuedu.vue' // 规章制度阅读
import jiaoshijiaoxuerizhi from '@/components/home/daibanshixiang/jiaoshijiaoxuerizhi/list.vue' // 教师教学日志
import susheweiguixuesheng from '@/components/home/daibanshixiang/susheweiguixuesheng/list.vue' // 宿舍未归学生
import huiyiguanli from '@/components/home/daibanshixiang/huiyiguanli/list.vue' // 会议管理
import kaohexiangmukaoheren from '@/components/home/daibanshixiang/jiaoshijiaoxuezhiliangkaohe/kaohe.vue' // 考核项目-考核人
import kaohexiangmupingjiaren from '@/components/home/daibanshixiang/jiaoshijiaoxuezhiliangkaohe/pingjia.vue' // 考核项目-评价人
import kaohexiangmupingjiarendetail from '@/components/home/daibanshixiang/jiaoshijiaoxuezhiliangkaohe/pingjiadetail.vue' // 考核项目-评价人
// 待办事项 结束

const props = defineProps({
  openDaiBanShiXiang: { type: Boolean, required: true }
})
const emits = defineEmits(['update:openDaiBanShiXiang', 'ReturnData'])

// 待办事项 BEGIN
const openAddRiChang = ref(false) // 添加日常工作
const lsgzAdd = ref(false) // 委派临时工作
const isSPXQ = ref(false) // 审批详情
const openZhiBanRiZhi = ref(false) // 值班日志
const openZhiBanRiZhiDetail = ref(false) // 值班日志详情
const openShiWuChuLi = ref(false) // 事务处理
const openShiWuChuLiDetail = ref(false) // 事务处理详情
const openShangChuanShiJuan = ref(false) // 上传试卷
const openShangChuanShiJuanDetail = ref(false) // 上传试卷详情
const openShenPiShiJuan = ref(false) // 审批试卷
const openShenPiShiJuanDetail = ref(false) // 审批试卷详情
const openTiaoKe = ref(false) // 教师调课
const openTiaoKeDetail = ref(false) // 教师调课详情
const openJiaoXueJianCha = ref(false) // 教师教学检查
const openJiaoXueJianChaDetail = ref(false) // 教师教学检查详情
const openDaiKe = ref(false) // 教师代课
// const openDaiKeDetail = ref(false) // 教师代课详情
const openWanChengLinShi = ref(false) // 完成临时工作
const openWanChengLinShiDetail = ref(false) // 完成临时工作详情
const openWanChengGuDing = ref(false) // 完成固定工作
const openWanChengGuDingDetail = ref(false) // 完成固定工作详情
const openWanChengRiChang = ref(false) // 完成日常工作
const openWanChengRiChangDetail = ref(false) // 完成日常工作详情
const openJiaoXueSheJi = ref(false) // 添加教学设计
const openJiaoXueSheJiDetail = ref(false) // 添加教学设计详情
const openBuZhiZuoYe = ref(false) // 添加布置工作
const openBuZhiZuoYeDetail = ref(false) // 添加布置工作详情
const openJiaoXueJiHua = ref(false) // 学期教学计划
const openJiaoXueJiHuaDetail = ref(false) // 学期教学计划详情
const openPiGaiZuoYe = ref(false) // 批改作业列表
// const openPiGaiZuoYeDetail = ref(false) // 批改作业列表详情
const openGuiZhangZhiDuYueDu = ref(false) // 规章制度阅读
const openKeJian = ref(false) // 上传课件
// const openKeJianDetail = ref(false) // 上传课件详情
const openJiaoXueRiZhi = ref(false) // 教师教学日志
// const openJiaoXueRiZhiDetail = ref(false) // 教师教学日志详情
const openXunJianDetail = ref(false) // 巡检详情
const openWeiGuiXueShengSuGuan = ref(false) // 宿舍未归学生统计-宿管
const openWeiGuiXueShengBanZhuRen = ref(false) // 宿舍未归学生统计-班主任
const openHuiYiGuanLi = ref(false) // 会议管理
const openKaoHeXiangMuKaoHeRen = ref(false) // 考核项目-考核人
const openKaoHeXiangMuPingJiaRen = ref(false) // 考核项目-评价人
const openKaoHeXiangMuPingJiaRenDetail = ref(false) // 考核项目-评价人

// const openEditYwp = ref(false) // 修改已委派
const openWeiPaiDetail = ref(false) // 委派详情
// 待办事项 END

const daiBanActive = ref('db')
const dbztData = ref(getdbzt()) // 待办状态
const dbRqqj = ref([]) // 日期区间
const paginationObj = ref({
  background: false,
  pageNo: 1,
  pageSize: 100,
  total: 0
  // layout: 'prev, pager, next, jumper, total'
})

const row = ref({}) // 传递行数据
const dbData = ref([]) // 待办数据
const gzrwLading = ref(false) // 待办加载状态
const dbParms = ref({
  ksyqwcsj: undefined, // 开始要求完成时间
  jsyqwcsj: undefined, // 结束要求完成时间
  dbgzlbid: undefined, // 待办工作类别id
  gzrwbt: undefined, // 工作任务标题
  order: 'yqwcsj', // 排序字段
  sort: 'desc', // 排序方式
  pageNo: 1, // 当前页码
  pageSize: 100 // 每页条数
})

const dataGrid = ref({
  sortChange: function (column) {
    dbParms.value.order = column.prop
    dbParms.value.sort = column.order
    initDaiBan()
  }
})
const initDaiBan = (pageNo, pageSize) => {
  dbData.value = []
  gzrwLading.value = true
  dbParms.value.ksyqwcsj = dbRqqj.value ? dbRqqj.value[0] : undefined
  dbParms.value.jsyqwcsj = dbRqqj.value ? dbRqqj.value[1] : undefined
  dbParms.value.dbgzlbid = dbParms.value.dbgzlbid || undefined
  dbParms.value.gzrwbt = dbParms.value.gzrwbt || undefined
  dbParms.value.order = dbParms.value.order || 'yqwcsj'
  dbParms.value.sort = dbParms.value.sort === 'ascending' ? 'asc' : 'desc'
  dbParms.value.pageNo = pageNo || 1
  dbParms.value.pageSize = pageSize || 100
  let url = ''
  switch (daiBanActive.value) {
    case 'db': // 待办
      dbParms.value.zt = ztData.value.dwc
      url = '/api/v2/bangong/bangongdaibanshixiang/ztlist'
      break
    case 'yb': // 已办
      dbParms.value.zt = ztData.value.ywc
      url = '/api/v2/bangong/bangongdaibanshixiang/ztlist'
      break
    case 'hl': // 忽略
      dbParms.value.zt = ztData.value.yhl
      url = '/api/v2/bangong/bangongdaibanshixiang/ztlist'
      break
    case 'yyj': // 已移交
      dbParms.value.zt = ztData.value.yyj
      url = '/api/v2/bangong/bangongdaibanshixiang/ztlist'
      break
    case 'ywp': // 已委派
      dbParms.value.zt = null
      url = '/api/v2/bangong/bangonglinshidaibanshixiang/list'
      break
    case 'jr': // 今日工作
      dbParms.value.zt = ztData.value.dwc
      url = '/api/v2/bangong/bangongdaibanshixiang/dangtiandaiban'
      break
    case 'bz': // 本周工作
      dbParms.value.zt = ztData.value.dwc
      url = '/api/v2/bangong/bangongdaibanshixiang/zhoudaiban'
      break
    case 'by': // 本月工作
      dbParms.value.zt = ztData.value.dwc
      url = '/api/v2/bangong/bangongdaibanshixiang/yuedaiban'
      break
  }
  actionPost({ url: url, data: dbParms.value }).then((res) => {
    if (res.code === 200) {
      const dqn = getDate('YYYY')
      const dqrq = getDate('YYYY', 'MM', 'DD', 'HH', 'mm')
      if (res.data.list) {
        res.data.list.forEach((element) => {
          element.isDydqrq = false
          if (element.yqwcsj) {
            const rq = element.yqwcsj.slice(0, 10)
            if (new Date(dqrq).getTime() > new Date(element.yqwcsj).getTime()) {
              element.isDydqrq = true
            }
            const nf = element.yqwcsj.slice(0, 4)
            // 当前年份去掉年
            if (dqn === nf) {
              element.yqwcsj = element.yqwcsj.slice(5, 16)
            }
            if (rq === '1970-01-01') {
              element.yqwcsj = element.yqwcsj.slice(11, 16)
            }
          }
        })
      }
      gzrwLading.value = false
      dbData.value = res.data.list // 返回列表
      paginationObj.value.pageNo = dbParms.value.pageNo
      paginationObj.value.pageSize = dbParms.value.pageSize
      paginationObj.value.total = res.data.total
      // handleCheckChange()
    } else {
      gzrwLading.value = false
      warningPrompt(res.message)
    }
  })
}

const timer = ref(null)
const lunXun = () => {
  timer.value = setInterval(async () => {
    setTimeout(function () {
      initDaiBan()
    }, 600)
  }, 60000)
}
// 监听鼠标键盘事件
watchEffect(() => {
  document.addEventListener('keydown', () => {
    clearInterval(timer.value)
    lunXun()
  })
  document.addEventListener('mousewheel', () => {
    clearInterval(timer.value)
    lunXun()
  })
  document.addEventListener('mousedown', () => {
    clearInterval(timer.value)
    lunXun()
  })
})
// 待办事项 忽略
const hulueClick = (item) => {
  actionPost({
    url: '/api/v2/bangong/bangongdaibanshixiang/hulue',
    data: { id: item.id }
  }).then((res) => {
    if (res.code === 200) {
      initDaiBan()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 待办事项 END

const gzlbData = ref([])
const initGongZuoLeiBei = () => {
  loadSelect({
    url: '/api/v2/bangong/bangongdaibanshixiang/dangqianyonghugongzuoleibie',
    data: gzlbData,
    order: 'gzlbmc',
    sort: 'asc'
  })
}
const ztData = ref({ listZhuangTai: [] })
const initZhuangTai = () => {
  loadSelect({
    url: '/api/v2/bangong/bangongdaibanshixiang/daibanzhuangtai',
    data: ztData
  })
}
const xtszData = ref({
  grzx: {},
  lsgz: {},
  rcgz: {},
  ywp: {},
  yyj: {},
  xtjs: {},
  xqgl: {},
  zbxx: {},
  zcd: {},
  zwty: {}
})
const initXiTongSheZhi = () => {
  actionPost({
    url: '/api/v2/sys/caidanxianshikongzhi/list',
    data: { order: 'cdwybs', sort: 'asc' }
  }).then((res) => {
    xtszData.value = {
      grzx: res.data.length
        ? res.data.find((item) => item.cdwybs === 'geRenZhongXin')
        : { cdwybs: 'geRenZhongXin', sfxs: true, cdlx: 0, bz: '个人中心' },
      lsgz: res.data.length
        ? res.data.find((item) => item.cdwybs === 'linShiGongZuo')
        : { cdwybs: 'linShiGongZuo', sfxs: true, cdlx: 0, bz: '首页-临时工作' },
      rcgz: res.data.length
        ? res.data.find((item) => item.cdwybs === 'riChangGongZuo')
        : {
            cdwybs: 'riChangGongZuo',
            sfxs: true,
            cdlx: 0,
            bz: '首页-日常工作'
          },
      ywp: res.data.length
        ? res.data.find((item) => item.cdwybs === 'yiWeiPai')
        : { cdwybs: 'yiWeiPai', sfxs: true, cdlx: 0, bz: '首页-已委派' },
      yyj: res.data.length
        ? res.data.find((item) => item.cdwybs === 'yiYiJiao')
        : { cdwybs: 'yiYiJiao', sfxs: true, cdlx: 0, bz: '首页-已移交' },
      xtjs: res.data.length
        ? res.data.find((item) => item.cdwybs === 'xiTongJieShao')
        : { cdwybs: 'xiTongJieShao', sfxs: true, cdlx: 0, bz: '系统介绍' },
      xqgl: res.data.length
        ? res.data.find((item) => item.cdwybs === 'xuQiuGuanLi')
        : { cdwybs: 'xuQiuGuanLi', sfxs: true, cdlx: 0, bz: '需求管理' },
      zbxx: res.data.length
        ? res.data.find((item) => item.cdwybs === 'zhiBanXinXi')
        : {
            cdwybs: 'zhiBanXinXi',
            sfxs: true,
            cdlx: 1,
            bz: '值班信息 1-办公值班 2-宿舍值班'
          },
      zcd: res.data.length
        ? res.data.find((item) => item.cdwybs === 'zhuCaiDan')
        : {
            cdwybs: 'zhuCaiDan',
            sfxs: true,
            cdlx: 1,
            bz: '主菜单 1-默认 2-小号一列'
          },
      zwty: res.data.length
        ? res.data.find((item) => item.cdwybs === 'zhiWuTongYong')
        : { cdwybs: 'zhiWuTongYong', sfxs: true, cdlx: 0, bz: '职务-通用' }
    }
    sessionStorage.setItem('XITONGSHEZHI', JSON.stringify(xtszData.value))
  })
  initDaiBan()
}
watch(
  () => props.openDaiBanShiXiang,
  () => {
    if (props.openDaiBanShiXiang) {
      lunXun()
      initXiTongSheZhi()
      initGongZuoLeiBei()
      initZhuangTai()
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
.button-box .el-button {
  margin-right: 10px;
  margin-left: 0;
}
</style>
